export { default as FreeButton } from './FreeButton.vue';
